import { Weight } from './enums';
import css from './style.module.css';

export const weightPresets: Record<Weight, string> = {
  [Weight.REGULAR]: css.regular,
  [Weight.SEMIBOLD]: css.semibold,
  [Weight.BOLD]: css.bold,
};
